<template>
  <v-card class="pa-4">
    <v-layout column v-if="data">
      <v-layout row justify-space-between>
        <h2 class="mb-4">Preview</h2>
        <v-btn fab small flat class="close-btn" absolute @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      </v-layout>
      <div class="content-wrap">
        <div v-if="data.prefixLines.length > 0" class="prefix-wrap pa-3">
          <template v-for="(prefix, i) in data.prefixLines">
            <p v-if="prefix.content === 'emptyline'" class="pb-3" :key="i"></p>
            <hr v-else-if="prefix.content === 'lineseparator'" class="my-3 lineseparator" :key="i">
            <hr v-else-if="prefix.content === 'equalseparator'" class="my-3 equalseparator" :key="i">
            <div v-else-if="prefix.content === 'image'" :key="i" class="img-wrap">
              <img :src="prefix.data" alt="">
            </div>
            <p
              v-else
              :style="{
                fontSize: `${prefix.fontHeight}px`,
                fontWeight: prefix.fontStyle === 'bold' ? 'bold' : null,
                fontStyle: prefix.fontStyle === 'italic' ? 'italic' : null,
              }"
              class="mb-0"
              :key="i">
              {{ prefix.content === 'opencashdrawer' ? 'open cashdrawer' : prefix.content }}
            </p>
          </template>
        </div>
        <p class="content mb-0 pa-3">Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum enim, perspiciatis,
          animi magnam vel placeat consequatur nisi architecto aut iure repudiandae debitis itaque fugit.
          Omnis facilis illo laudantium consequuntur perspiciatis?</p>
        <div v-if="data.postfixLines.length > 0" class="postfix-wrap pa-3">
          <template v-for="(postfix, index) in data.postfixLines">
            <p v-if="postfix.content === 'emptyline'" class="pb-3" :key="index"></p>
            <hr v-else-if="postfix.content === 'lineseparator'" class="my-3 lineseparator" :key="index">
            <hr v-else-if="postfix.content === 'equalseparator'" class="my-3 equalseparator" :key="index">
            <div v-else-if="postfix.content === 'image'" :key="index" class="img-wrap">
              <img :src="postfix.data" alt="">
            </div>
            <p
              v-else
              :style="{
                fontSize: `${postfix.fontHeight}px`,
                fontWeight: postfix.fontStyle === 'bold' ? 'bold' : null,
                fontStyle: postfix.fontStyle === 'italic' ? 'italic' : null,
              }"
              class="mb-0"
              :key="index">
              {{ postfix.content === 'opencashdrawer' ? 'open cashdrawer' : postfix.content }}
            </p>
          </template>
        </div>
      </div>
    </v-layout>
    <v-layout column v-if="image">
      <v-layout row justify-space-between>
        <h2 class="mb-4">Preview</h2>
        <v-btn fab small flat class="close-btn" absolute @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      </v-layout>
      <div class="content-wrap">
        <div class="prefix-wrap pa-3">
          <div class="img-wrap fluid">
            <img :src="image.base64Image" alt="">
          </div>
        </div>
      </div>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['data', 'image'],
  };
</script>

<style lang="scss" scoped>
  .close-btn {
    right: 14px;
    top: 14px;
  }
  .content-wrap {
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  .postfix-wrap {
    border-top: 1px solid rgba(0, 0, 0, 0.1)
  }
  .prefix-wrap {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .lineseparator, .equalseparator {
    position: relative;
    border-bottom: 2px dashed rgba(0, 0, 0, 0.4);
    width: 100%;
    background: none;
  }
  .equalseparator {
    padding-top: 5px;
    &::after {
      content: '';
      display: block;
      height: 2px;
      border-bottom: 2px dashed rgba(0, 0, 0, 0.4);
      position: absolute;
      bottom: 3px;
      width: 100%;
    }
  }
  .img-wrap {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: auto;
    max-height: 90%;
    display: flex;
    img {
      align-self: center;
      height: auto;
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// PreviewPrePost.vue?c8d96ef2